import React from "react";
import { useNavigate } from "react-router-dom";
import { useAccessibility } from "../../hooks/useAccessibility";
import { KeyboardShortcuts } from "./KeyboardShortcuts";

export const GlobalAccessibility: React.FC = () => {
  const navigate = useNavigate();
  const {
    toggleHighContrast,
    increaseFontSize,
    decreaseFontSize,
    resetFontSize,
    settings,
  } = useAccessibility();
  const [shortcutsOpen, setShortcutsOpen] = React.useState(false);

  React.useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      // Avoid interfering with text inputs
      const target = e.target as HTMLElement | null;
      const isTyping = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable);
      if (isTyping) return;

      // Shift + / => show help ("?")
      if (e.shiftKey && e.key === '/') {
        setShortcutsOpen(true);
        e.preventDefault();
        return;
      }

      // Alt + h => toggle high contrast
      if (e.altKey && (e.key === 'h' || e.key === 'H')) {
        toggleHighContrast();
        e.preventDefault();
        return;
      }

      // Ctrl/Cmd + '+' | '-' | '0' => font size controls
      const isAccel = e.ctrlKey || e.metaKey;
      if (isAccel && (e.key === '+' || e.key === '=')) {
        increaseFontSize();
        e.preventDefault();
        return;
      }
      if (isAccel && e.key === '-') {
        decreaseFontSize();
        e.preventDefault();
        return;
      }
      if (isAccel && e.key === '0') {
        resetFontSize();
        e.preventDefault();
        return;
      }

      // g then s => go to settings
      // g then a => go to accessibility settings
      // Simple state machine
      if ((e.key === 'g' || e.key === 'G')) {
        (window as any).__ga_seq = 'g';
        setTimeout(() => { (window as any).__ga_seq = null; }, 1000);
        return;
      }
      if ((window as any).__ga_seq === 'g') {
        if (e.key.toLowerCase() === 's') {
          navigate('/dashboard/settings');
          (window as any).__ga_seq = null;
          e.preventDefault();
          return;
        }
        if (e.key.toLowerCase() === 'a') {
          navigate('/dashboard/settings/accessibility');
          (window as any).__ga_seq = null;
          e.preventDefault();
          return;
        }
        (window as any).__ga_seq = null;
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [navigate, toggleHighContrast, increaseFontSize, decreaseFontSize, resetFontSize, settings.keyboardShortcuts]);

  return (
    <>
      <KeyboardShortcuts isOpen={shortcutsOpen} onClose={() => setShortcutsOpen(false)} />
    </>
  );
};

export default GlobalAccessibility;
